import ApplicationPaymentsDetailsComp from "../components/applications/ApplicationPaymentsDetails";

export default function ApplicationPaymentsDetails() {
  return <ApplicationPaymentsDetailsComp />;
}
